
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { HTTP_CONFIG, AUTH_CONFIG } from 'src/app/configs';

import Amplify from '@aws-amplify/core';
Amplify.configure({
  Auth: AUTH_CONFIG,
  API: {
    endpoints: [
      {
        name: HTTP_CONFIG.apiName,
        endpoint: HTTP_CONFIG.apiUrl+HTTP_CONFIG.apiStage,
        region: HTTP_CONFIG.region
      }
    ] 
  }
});

if (environment.production) {
  enableProdMode();
  window.console.log = function () { };
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));


Array.prototype['intersect'] = function(...a) {
  return [this,...a].reduce((p,c) => p.filter(e => c.includes(e)));
}

Array.prototype['setSort'] = function(a = 'asc') {
  if(a == 'desc')
    return this.reverse();
    
  return this;
}

Array.prototype['shuffle'] = function() {
  let m = this.length, i;
  while (m) {
    i = (Math.random() * m--) >>> 0;
    [this[m], this[i]] = [this[i], this[m]]
  }
  return this;
}